// extracted by mini-css-extract-plugin
module.exports = {"container":"CurrencyValue_container__BkdYP","mute":"CurrencyValue_mute__BrgNR","value":"CurrencyValue_value__apB_P","strong":"CurrencyValue_strong__SU35p"};